interface FourOhFourEventData {
	location: Location;
}

export const getData = (location: Location): FourOhFourEventData => {
	// 404 event
	return {
		location: location,
	};
};
